var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.595703 4.83942C0.595703 2.70414 2.47931 0.973145 4.80285 0.973145H11.8886C14.2121 0.973145 16.0957 2.70414 16.0957 4.83942V14.6069C16.0957 16.7422 14.2121 18.4731 11.8886 18.4731H4.80285C2.47931 18.4731 0.595703 16.7422 0.595703 14.6069V4.83942ZM4.80285 5.04291C4.43597 5.04291 4.13856 5.31623 4.13856 5.65338C4.13856 5.99053 4.43597 6.26384 4.80285 6.26384H11.8886C12.2554 6.26384 12.5528 5.99053 12.5528 5.65338C12.5528 5.31623 12.2554 5.04291 11.8886 5.04291H4.80285ZM4.13856 9.72314C4.13856 9.38599 4.43597 9.11268 4.80285 9.11268H11.8886C12.2554 9.11268 12.5528 9.38599 12.5528 9.72314C12.5528 10.0603 12.2554 10.3336 11.8886 10.3336H4.80285C4.43597 10.3336 4.13856 10.0603 4.13856 9.72314ZM4.80285 13.1824C4.43597 13.1824 4.13856 13.4558 4.13856 13.7929C4.13856 14.1301 4.43597 14.4034 4.80285 14.4034H8.3457C8.71258 14.4034 9.00999 14.1301 9.00999 13.7929C9.00999 13.4558 8.71258 13.1824 8.3457 13.1824H4.80285Z",
    fill: "#2B3F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.242b7e644cdfbec1f1d19579a442090f.svg";
export { ForwardRef as ReactComponent };